module.exports = __webpack_public_path__ + "img/vignettes-asso_0007_reseau-profamille.1d4f4b88.jpg";